import Vue from 'vue';

export function getNotificationsAudioMixin(audioFileName: string) {
  return Vue.extend({
    data() {
      return {
        audio: (null as unknown) as HTMLAudioElement,
      };
    },
    methods: {
      playAudio() {
        try {
          this.audio = new Audio(`${process.env.BASE_URL}audio/${audioFileName}.wav`);
          this.audio.volume = 0.2;
          this.audio.play();
        } catch {
          console.warn('Audio file could not be played. Please consider using another browser.');
        }
      },
      stopAudio() {
        try {
          this.audio.pause();
        } catch {
          console.warn('Audio file could not be played. Please consider using another browser.');
        }
      },
    },
  });
}
